
export const GEO_ART_SORTING_IDX= {
    1: 1,
    2: 2,
    20: 20
}

export const DEZIIGN_SORTING_IDX= {
    // 1: 11,
    1: 19,
    // 2: 12
    2: 15,
    13: 13,
    20: 20,
}

export const DEZIIIGN_MAIN_IDX = {
    1: 18,
    2: 15,
    20: 20,
    26: 26
}

export const HSE_SORTING_IDX = {
    1: 18,
    2: 15,
    20: 20
}

export const GEO_ART_SORTING_IDX= {
    1: 1,
    2: 2,
    20: 20
}

export const DEZIIGN_SORTING_IDX= {
    // 1: 11,
    1: 19,
    // 2: 12
    2: 15,
    13: 13,
    20: 20,
}

export const DEZIIIGN_MAIN_IDX = {
    1: 18,
    2: 15,
    20: 20,
    26: 26
}

export const HSE_SORTING_IDX = {
    1: 18,
    2: 15,
    20: 20
}
